<template>
    <h1>SQL Editor</h1>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'TableSqlEditor'
})
</script>

<style scoped lang="scss">

</style>
